<template>
    <ul v-show="isOpen">
        <li class="branch" v-for="(product, index) in products" :key="index">
            <i
                    @click="showVariants(index)"
                    :class="isActive(index) ? 'indicator glyphicon glyphicon-minus-sign' : 'indicator glyphicon glyphicon-plus-sign'"
            ></i>
            <a href="#" @click="showVariants(index)">{{product.name}}</a>
            <ul v-if="isActive(index)">
                <li v-for="variant in product.variants" class="clearfix b-products-tree__varinant-item" style="">
                    <p class="pull-left col-md-6">
                        <label class="b-products-tree__label">
                            <input
                                    :id="'variant_id_' + variant.id"
                                    class="b-products-tree__variant-checkbox"
                                    type="checkbox"
                                    :value=variant.id
                                    autocomplete="off"
                                    :disabled="variant.available_quantity == 0"
                            >
                            {{ variant.title}}
                        </label>
                    </p>
                    <p class="pull-right col-md-6">
                        - {{variant.available_quantity }} <span>{{translations.pieces}}</span>
                    </p>
                </li>
            </ul>
        </li>
    </ul>
</template>

<script>
    export default {
        props: ['brand', 'isOpen', 'translations'],
        data() {
            return {
                products: [],
                activeIndex: null
            };
        },
        watch: {
            isOpen: function (isOpened) { // watch it
                if (isOpened) {
                    this.getProductsByBrandId(this.brand.id);
                }
            }
        },
        methods: {
            getProductsByBrandId(brandId) {
                let params = {
                    brand_id: brandId
                };
                this.$http.get('/catalog/products/get_tree_products', params)
                    .then(function (response) {
                        this.products = response.data;
                    });
            },
            showVariants(productId) {
                if (this.activeIndex == productId) {
                    this.activeIndex = null;
                    return;
                }
                this.activeIndex = productId;
            },
            isActive(index) {
                return this.activeIndex == index;
            }
        }
    };
</script>
